import { jsx } from "react/jsx-runtime";
import iconLibrary from "./internal/icon-library.js";
const Icon = (props) => {
  const { icon: icon2, size = 16, ...otherProps } = props || {};
  const renderIcon = iconLibrary[icon2];
  return renderIcon({
    ...otherProps,
    size,
    // Unless we have a label, we need to hide the icon from screen readers
    "aria-hidden": !otherProps["aria-label"] && !otherProps["aria-labelledby"],
    "data-icon": icon2
  });
};
const icon = (icon2, props) => {
  return jsx(Icon, { icon: icon2, ...props });
};
export {
  Icon,
  icon
};
